import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { Database, getDatabase } from "firebase/database";
import { getAuth, connectAuthEmulator, type Auth } from "firebase/auth";
import config from "../config";

// Initialize Firebase
const firebaseApp = initializeApp(config.firebaseConfig);

const firebaseAuth: Auth = getAuth(firebaseApp);
const db: Database = getDatabase(firebaseApp);

firebaseAuth.useDeviceLanguage();

if (import.meta.env.DEV) {
  connectAuthEmulator(firebaseAuth, "http://localhost:9099", { disableWarnings: true });
}

getAnalytics(firebaseApp);

export { firebaseAuth, db };

export default firebaseApp;
